// Value-noise fBm. Not a Perlin/simplex clone — smoothstep-interpolated value
// noise is enough for this palette and keeps the engine dependency-free.
import { mulberry32 } from '../rng.js'
import { gradientAngle } from './gradient.js'

function buildLattice(seed, size) {
  const rnd = mulberry32(seed)
  const g = new Float32Array(size * size)
  for (let i = 0; i < g.length; i++) g[i] = rnd() * 2 - 1
  return g
}

const fade = (t) => t * t * (3 - 2 * t)
const lerp = (a, b, t) => a + (b - a) * t

export default {
  id: 'noise',
  label: 'Noise (fBm)',
  params: [
    { key: 'octaves', label: 'octaves', tier: 'structural', min: 1, max: 6, step: 1, default: 3 },
    { key: 'scale', label: 'scale', tier: 'continuous', min: 0.5, max: 12, step: 0.1, default: 3 },
    { key: 'gain', label: 'gain', tier: 'continuous', min: 0.2, max: 0.9, step: 0.05, default: 0.5 },
    { key: 'amplitude', label: 'amplitude', tier: 'continuous', min: 0.1, max: 1.5, step: 0.05, default: 0.7 },
    { key: 'drift', label: 'drift', tier: 'continuous', min: 0, max: 3, step: 0.05, default: 0.6 },
  ],

  create(cfg, seed) {
    const SIZE = 64
    const lat = buildLattice(seed, SIZE)
    const at = (ix, iy) => lat[(((iy % SIZE) + SIZE) % SIZE) * SIZE + (((ix % SIZE) + SIZE) % SIZE)]

    const value = (x, y) => {
      const x0 = Math.floor(x), y0 = Math.floor(y)
      const fx = fade(x - x0), fy = fade(y - y0)
      return lerp(
        lerp(at(x0, y0), at(x0 + 1, y0), fx),
        lerp(at(x0, y0 + 1), at(x0 + 1, y0 + 1), fx),
        fy,
      )
    }

    const sample = (x, y, t) => {
      let v = 0, amp = 1, freq = cfg.scale, norm = 0
      for (let o = 0; o < cfg.octaves; o++) {
        v += value(x * freq + t * cfg.drift, y * freq) * amp
        norm += amp
        amp *= cfg.gain
        freq *= 2
      }
      return (v / (norm || 1)) * cfg.amplitude
    }

    return { sample, gradient: (x, y, t) => gradientAngle(sample, x, y, t) }
  },
}
